<template>
  <form>
    <label v-if="forChar > 0" for="for-personalisation-input" class="personalisation-overlay-details--label">for</label>
    <div class="form-input">
      <input
        class="sensitive"
        :disabled="adding"
        ref="forInput"
        id="for-personalisation-input"
        placeholder="for"
        :maxlength="forCharMax"
        v-model='forInput'
        type="text"
      />
      <span :class="forChar > forCharMax ? 'count-over' : 'count'" >{{forChar}}/{{forCharMax}}</span>
    </div>
    <form @submit.prevent>
      <button style="width: 100%" :class="adding || forChar === 0 ? 'preview-button--disabled' : 'preview-button'" @click="addToCart">Add to cart</button>
    </form>
  </form>
</template>
<script>


import { mapGetters } from "vuex";
import { isEmpty } from "lodash-es";
import events from "Assets/js/components/events";
export default {
  name: "BottledByFor",
  props: {
    adding: Boolean,
    variantId: String,
    productId: String,
    setActive: Function,
    setAdding: Function,
    b2bCart: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      forInput: '',
      bottledByCharMax: 10,
      forCharMax: 18,
    }
  },
  beforeMount() {
    // For B2B: init fields
    if (!isEmpty(this.b2bCart) && this.b2bCart.bottledByMessage) {
      this.forInput = this.b2bCart.bottledByMessage.for;
    }
  },
  computed: {
    ...mapGetters([
      'cartInstance'
    ]),
    forChar(){
      return this.forInput.length;
    }
  },
  methods: {
    addToCart() {
      if(this.forInput > this.forCharMax){
        return;
      }
      this.setAdding(true);
      const message = {
        for: this.forInput,
      };

      if (!isEmpty(this.b2bCart)) {
        this.cartInstance.updateB2BCartWithBottledBy(
          this.b2bCart.lineItemId,
          this.b2bCart.lineItemAttributes,
          message,
          (responseData) => {
            if (responseData.status === 200) {
              this.setActive(false);
              this.setAdding(false);
            }

            // Trigger cart change event
            events.cartChange(this.cartInstance.getCart());

            // Trigger callback
            if (typeof this.b2bCart.callback === "function") {
              this.b2bCart.callback(message);
            }
          });
      } else {
        this.cartInstance.addToCartWithBottledBy(this.variantId, message, this.productId, (responseData) => {
          if (responseData.status === 200) {
            this.setActive(false);
            this.setAdding(false);
          }

          // Trigger cart change event
          events.cartChange(this.cartInstance.getCart());
        });
      }
    },
  },

}
</script>
